/**
 * @generated SignedSource<<0d16eced65bfd4756050fb4329d9ce34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dividendsPage_PeriodTotalMutation$variables = {
  period: string;
  totalCents?: number | null | undefined;
};
export type dividendsPage_PeriodTotalMutation$data = {
  readonly dividendSetPeriodTotal: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly saved: boolean | null | undefined;
  } | null | undefined;
};
export type dividendsPage_PeriodTotalMutation = {
  response: dividendsPage_PeriodTotalMutation$data;
  variables: dividendsPage_PeriodTotalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "period"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "totalCents"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "period",
    "variableName": "period"
  },
  {
    "kind": "Variable",
    "name": "totalCents",
    "variableName": "totalCents"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saved",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_PeriodTotalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DividendSetPeriodTotalMutationPayload",
        "kind": "LinkedField",
        "name": "dividendSetPeriodTotal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_PeriodTotalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DividendSetPeriodTotalMutationPayload",
        "kind": "LinkedField",
        "name": "dividendSetPeriodTotal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a839b95ca88bc8f74a8ed50890aa723",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_PeriodTotalMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_PeriodTotalMutation(\n  $period: String!\n  $totalCents: Int\n) {\n  dividendSetPeriodTotal(period: $period, totalCents: $totalCents) {\n    saved\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fdb380affccc4cbf6b3516c35015c7ad";

export default node;
